module.exports = __webpack_public_path__ + "media/Images/icon-user-with-box-o-18206364d324a437c1808c4184d08c2c.svg";